module.exports = __webpack_public_path__ + "img/logo.15d43e14.svg";